import React, { useEffect, useState } from 'react';
import { useSelector, connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccountCircle from '@material-ui/icons/AccountCircle';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Field, reduxForm, change } from 'redux-form';
import IxDatePickerHtml from '../../../basic/ix-datepicker-html';
import IxRadioGroup from '../../../basic/ix-radio-group';
import CustomerValidate from '../registration-validation';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { NavLink, BrowserRouter as Router } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import TakeoutBottomFunction from '../../../basic/takeout-bottom-function';

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  link: {
    color: '#1A1311',
    'text-decoration': 'none'
  },
  dateField: {
    width: '100%',
    marginTop: '1rem !important',
    marginLeft: '-1px !important'
  },
  formFiledContainer: {
    '& .MuiBox-root': {
      height: '20vh',
      overFlowY: 'auto'
    }
  },
  formTitle: {
    textAlign: 'center',
    fontSize: '1.8rem',
    marginBottom: theme.spacing(6),
    paddingTop: theme.spacing(5)
  },
  radioButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}));

const renderField = ({
  handleClickShowPassword,
  input,
  label,
  isPassword,
  meta: { touched, invalid, error },
  ...custom
}) => {
  const opt = {};
  (input.name === 'password' || input.name === 'confirmPassword') &&
    (opt.endAdornment = (
      <InputAdornment position='end'>
        <IconButton
          aria-label='toggle password visibility'
          onClick={handleClickShowPassword}
          // onMouseDown={handleMouseDownPassword}
          edge='end'
        >
          {isPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    ));

  return (
    <TextField
      variant='outlined'
      margin='normal'
      fullWidth
      label={label}
      error={touched && invalid}
      helperText={touched && error}
      autoComplete={label}
      InputProps={opt}
      {...input}
      {...custom}
    />
  );
};

let RegistrationForm = props => {
  const { handleSubmit, touchedOnLoad, history } = props;
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [showReEnteredPassword, setShowReEnteredPassword] = useState(false);
  const { t, i18n } = useTranslation();
  const loggedInUser =  useSelector((state) => state.appState.registeredUser.data);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowReEnteredPassword = () => {
    setShowReEnteredPassword(!showReEnteredPassword);
  };

  return (
    <form onSubmit={handleSubmit}>
      <p className={classes.formTitle}>{!loggedInUser && t('createAcc')}</p>

      <Box pl={2} pr={2} mt={-3} className={classes.formFiledContainer}>
        <Field name='lastName' component={renderField} label={t('lastName')} />

        <Field name='firstName' component={renderField} label={t('firstName')} />

        {!loggedInUser && <Field name='address' component={renderField} label={t('address')} />}

        <Field
          name='email'
          component={renderField}
          label={t('Email')+'*'}
          type='email'
        />

        <Field name='phone' component={renderField} label={t('Phone')} />
        {!loggedInUser && <Field
          name='password'
          isPassword={showPassword}
          component={renderField}
          label={t('Password')+'*'}
          type={showPassword ? 'text' : 'password'}
          handleClickShowPassword={handleClickShowPassword}
        />}
        {!loggedInUser && <Field
          name='confirmPassword'
          isPassword={showReEnteredPassword}
          component={renderField}
          label={t('reEnterPass')+'*'}
          type={showReEnteredPassword ? 'text' : 'password'}
          handleClickShowPassword={handleClickShowReEnteredPassword}
        />}

        <Field
          name='dob'
          component={IxDatePickerHtml}
          label={t('dob')}
          touchedOnLoad={touchedOnLoad}
          className={classes.dateField}
        />

        <Grid container>
          <Grid item xs={12} md={2}>
            <Box>
              <Field name='gender' component={IxRadioGroup}>
                <div className={classes.radioButtonContainer}>
                  <FormControlLabel
                    classes={{ label: classes.formControlLabelFirstItem }}
                    value={'MALE'}
                    control={<Radio color='primary' />}
                    label={t('Male')}
                  />

                  <FormControlLabel
                    classes={{ label: classes.formControlLabelFirstItem }}
                    value={'FEMALE'}
                    control={<Radio color='primary' />}
                    label={t('Female')}
                  />

                  <FormControlLabel
                    classes={{ label: classes.formControlLabelFirstItem }}
                    value={'OTHER'}
                    control={<Radio color='primary' />}
                    label={t('Other')}
                  />
                </div>
              </Field>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Grid container direction='column'>
        <TakeoutBottomFunction
          history={history}
          rightChildText={!loggedInUser ? t('Create Account') : t('Update')}
          leftBtnLink={t('Cancel')}
        ></TakeoutBottomFunction>
      </Grid>
    </form>
  );
};

const mapStateToProps = (state, props) => {
  const loggedInUser =  state.appState.registeredUser.data;

  return {
    initialValues: {
      firstName: loggedInUser ? loggedInUser.firstName : null,
      lastName: loggedInUser ? loggedInUser.lastName : null,
      email: loggedInUser ? loggedInUser.email : null,
      phone: loggedInUser ? loggedInUser.phone : null,
      dob: loggedInUser ? loggedInUser.dob : null,
      gender: loggedInUser ? loggedInUser.gender : null
    }
  };
};

RegistrationForm = reduxForm({
  form: 'RegistrationForm', //                 <------ same form name
  //destroyOnUnmount: false, //        <------ preserve form data
  //forceUnregisterOnUnmount: true // <------ unregister fields on unmount
  validate: CustomerValidate
})(RegistrationForm);

export default connect(mapStateToProps)(RegistrationForm);
